export default __webpack_public_path__ + "static/media/ProximaNova-Black.5335144c.ttf";